module.exports = __webpack_public_path__ + "static/media/carry-and-lowell.f078056e.jpg";